<child-onboarding-container
  [formValid]="isFormValid$ | async"
  [loading]="store.sendingLegalGuardian2Information$ | async"
  (back)="service.goToPreviousStep()"
  (forward)="submit()"
>
  <p class="zero-text p-huge-med">{{ 'child-onboarding.legal-guardian-2.headline' | transloco }}</p>
  <p class="zero-text p-base-reg">{{ 'child-onboarding.legal-guardian-2.text' | transloco }}</p>
  <p class="zero-text p-base-reg" [innerHTML]="'child-onboarding.legal-guardian-2.text2' | transloco"></p>
  <p class="zero-text p-base-reg">{{ 'child-onboarding.legal-guardian-2.text3' | transloco }}</p>
  <web-design-system-input
    class="d-block mt-4"
    type="number"
    labelSize="small"
    [value]="customerId$ | async"
    [isValid]="(customerId$ | async) && !(customerId$ | async | customerId)"
    [error]="customerId$ | async | customerId | transloco"
    [label]="'child-onboarding.legal-guardian-2.customer-id.label' | transloco"
    (valueChange)="handleCustomerIdChange($event)"
  />
  <a
    class="link-secondary mt-2"
    href="https://hilfe.finanzen.net/hc/de/articles/15653218567452-ZERO-Depot-Verwaltungsbereich "
    target="_blank"
    rel="nofollow noopener"
  >
    {{ 'child-onboarding.legal-guardian-2.customer-id-link' | transloco }}
  </a>
  <p class="zero-text p-base-reg mt-2">{{ 'child-onboarding.legal-guardian-2.birth-date' | transloco }}</p>
  <div class="d-flex gap justify-content-between">
    <web-design-system-input
      type="number"
      labelSize="small"
      [value]="birthDay$ | async"
      [isValid]="birthDay$ | async | day: (birthMonth$ | async) : (birthYear$ | async)"
      [label]="'child-onboarding.legal-guardian-2.birthDay' | transloco"
      (valueChange)="handleBirthDayChange($event)"
    />
    <web-design-system-input
      type="number"
      labelSize="small"
      [value]="birthMonth$ | async"
      [isValid]="birthMonth$ | async | month: (birthDay$ | async) : (birthYear$ | async)"
      [label]="'child-onboarding.legal-guardian-2.birthMonth' | transloco"
      [focus]="(focussedField$ | async) === 'birthMonth'"
      (valueChange)="handleBirthMonthChange($event)"
    />
    <web-design-system-input
      type="number"
      labelSize="small"
      [value]="birthYear$ | async"
      [isValid]="birthYear$ | async | year: (birthDay$ | async) : (birthMonth$ | async)"
      [label]="'child-onboarding.legal-guardian-2.birthYear' | transloco"
      [focus]="(focussedField$ | async) === 'birthYear'"
      (valueChange)="handleBirthYearChange($event)"
    />
  </div>
  @if (birthdateError$ | async; as errorType) {
    <p class="zero-text course-red p-small-reg mt-2">{{ 'child-onboarding.legal-guardian-2.birth-date-error' | transloco }}</p>
  }
  <p class="zero-text p-small-lig mt-2">{{ 'child-onboarding.legal-guardian-2.birth-date-hint' | transloco }}</p>
  <div class="zero-text p-base-reg">{{ 'child-onboarding.legal-guardian-2.login-hint' | transloco }}</div>
</child-onboarding-container>
